(function () {
  const cache = {};
  const MAX_LIVE_REVIEWS = 7;
  const MARK_JSON = /^\|\|OR\|\|(\{[\s\S]*?\})\|\|\s*/;
  const MARK_LINE = /^ORREV;([^;]+);([1-5]);(.*)$/;

  function resolveLocaleUrl(url, locale) {
    const code = (locale || 'es').split('-')[0].toLowerCase();
    if (!code || code === 'es') return url;
    return url.replace(/\.json(\?|$)/, '.' + code + '.json$1');
  }

  async function loadData(url) {
    if (cache[url]) return cache[url];
    const res = await fetch(url);
    if (!res.ok) throw new Error('Reviews fetch failed');
    cache[url] = await res.json();
    return cache[url];
  }

  async function loadLocalized(url, locale) {
    const localized = resolveLocaleUrl(url, locale);
    if (localized !== url) {
      try {
        const res = await fetch(localized);
        if (res.ok) {
          cache[localized] = await res.json();
          return cache[localized];
        }
      } catch (e) {}
    }
    return loadData(url);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function starsHtml(rating) {
    const full = Math.floor(rating);
    const half = rating % 1 >= 0.5;
    let html = '<span class="product-custom-reviews__stars" aria-hidden="true">';
    for (let i = 1; i <= 5; i += 1) {
      if (i <= full) {
        html += '<span class="product-custom-reviews__star is-full">★</span>';
      } else if (i === full + 1 && half) {
        html += '<span class="product-custom-reviews__star is-half">★</span>';
      } else {
        html += '<span class="product-custom-reviews__star">★</span>';
      }
    }
    html += '</span>';
    return html;
  }

  function daysLabel(days, labels) {
    if (!days) return labels.daysToday || 'hoy';
    if (days === 1) return labels.daysOne || 'hace 1 día';
    return (labels.daysOther || 'hace {{ count }} días').replace('{{ count }}', String(days));
  }

  function renderReview(review, labels, index, total) {
    const article = document.createElement('article');
    article.className = 'product-custom-reviews__item';
    article.setAttribute('role', 'group');
    article.setAttribute('aria-roledescription', 'slide');
    article.setAttribute('aria-label', `${index + 1} / ${total}`);
    const city = review.city ? `, ${escapeHtml(review.city)}` : '';
    const badge = review.verified === false
      ? (labels.customer || 'Clienta')
      : labels.verified;
    article.innerHTML = `
      <div class="product-custom-reviews__item-top">
        ${starsHtml(review.stars)}
        <span class="product-custom-reviews__verified">${escapeHtml(badge)}</span>
      </div>
      <p class="product-custom-reviews__text">${escapeHtml(review.text)}</p>
      <p class="product-custom-reviews__meta">
        <strong>${escapeHtml(review.author)}</strong>${city} · ${escapeHtml(daysLabel(review.days_ago, labels))}
      </p>
    `;
    return article;
  }

  function resetControl(el) {
    if (!el || !el.parentNode) return el;
    const clone = el.cloneNode(true);
    el.parentNode.replaceChild(clone, el);
    return clone;
  }

  function initCarousel(container, count) {
    const carousel = container.querySelector('.product-custom-reviews__carousel');
    let prev = container.querySelector('.product-custom-reviews__nav--prev');
    let next = container.querySelector('.product-custom-reviews__nav--next');
    const list = container.querySelector('[id^="ProductCustomReviewsList-"]');
    const dotsWrap = container.querySelector('.product-custom-reviews__dots');
    if (!carousel || !list || count < 1) {
      if (carousel) carousel.hidden = true;
      return;
    }

    carousel.hidden = false;
    prev = resetControl(prev);
    next = resetControl(next);

    if (count < 2) {
      carousel.classList.add('is-single');
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      if (dotsWrap) dotsWrap.hidden = true;
      list.style.transform = '';
      return;
    }

    carousel.classList.remove('is-single');
    if (prev) prev.hidden = false;
    if (next) next.hidden = false;
    if (dotsWrap) dotsWrap.hidden = false;

    let index = 0;
    const dots = [];

    function goTo(nextIndex) {
      index = (nextIndex + count) % count;
      list.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.tabIndex = active ? 0 : -1;
      });
    }

    dotsWrap.replaceChildren();
    for (let i = 0; i < count; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'product-custom-reviews__dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `${i + 1} / ${count}`);
      dot.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }

    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1);
      }
    });

    let startX = 0;
    let tracking = false;
    const viewport = container.querySelector('.product-custom-reviews__viewport');
    viewport.addEventListener('touchstart', (event) => {
      tracking = true;
      startX = event.changedTouches[0].clientX;
    }, { passive: true });
    viewport.addEventListener('touchend', (event) => {
      if (!tracking) return;
      tracking = false;
      const dx = event.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      goTo(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });

    goTo(0);
  }

  function readLiveComments(container) {
    const node = container.querySelector('[data-or-live-reviews]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function htmlToText(value) {
    const html = String(value || '');
    if (!html) return '';
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return (doc.body && doc.body.textContent) || '';
    } catch (e) {
      return html.replace(/<[^>]+>/g, ' ');
    }
  }

  function parseReviewMeta(rawBody) {
    const body = htmlToText(rawBody).replace(/\u00a0/g, ' ').trim();
    if (!body) return null;

    const lines = body.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
    const first = lines[0] || '';
    const lineMatch = first.match(MARK_LINE);
    if (lineMatch) {
      return {
        h: lineMatch[1],
        s: Number(lineMatch[2]),
        c: lineMatch[3] || '',
        text: lines.slice(1).join(' ').trim(),
      };
    }

    const jsonMatch = body.match(MARK_JSON);
    if (jsonMatch) {
      try {
        const meta = JSON.parse(jsonMatch[1]);
        return {
          h: meta.h,
          s: Number(meta.s),
          c: meta.c || '',
          text: body.slice(jsonMatch[0].length).trim(),
        };
      } catch (e) {}
    }

    const handleMatch = body.match(/ORREV;([a-z0-9-]+);/i)
      || body.match(/["']h["']\s*:\s*["“”]?([a-z0-9-]+)/i)
      || body.match(/"h"\s*:\s*["“”]?([a-z0-9-]+)/i);
    const cityMatch = body.match(/["']c["']\s*:\s*["“”]?([^"“”}\n]+)/i);
    const starsMatch = body.match(/["']s["']\s*:\s*([1-5])/i) || body.match(/ORREV;[a-z0-9-]+;([1-5]);/i);
    if (handleMatch) {
      const afterJson = body.replace(/^[\s\S]*?\{[\s\S]*?\}/, '').trim();
      return {
        h: handleMatch[1],
        s: starsMatch ? Number(starsMatch[1]) : 5,
        c: cityMatch ? cityMatch[1].trim() : '',
        text: afterJson || lines.slice(1).join(' ').trim(),
      };
    }
    return null;
  }

  function parseLive(raw, productHandle) {
    const list = [];
    if (!Array.isArray(raw) || !productHandle) return list;
    const now = Math.floor(Date.now() / 1000);
    raw.forEach((item) => {
      const meta = parseReviewMeta(item && item.body);
      if (!meta || meta.h !== productHandle) return;
      if (!(meta.s >= 1 && meta.s <= 5)) return;
      const text = String(meta.text || '').trim();
      if (text.length < 8) return;
      const created = Number(item.created_at) || now;
      list.push({
        author: item.author || 'Clienta',
        city: meta.c || '',
        stars: meta.s,
        text,
        days_ago: Math.max(0, Math.floor((now - created) / 86400)),
        verified: false,
        _ts: created,
      });
    });
    list.sort((a, b) => b._ts - a._ts);
    return list;
  }

  function reviewKey(review) {
    return `${String(review.author || '').trim().toLowerCase()}|${String(review.text || '').trim().toLowerCase()}`;
  }

  function uniqueReviews(list) {
    const seen = new Set();
    return (list || []).filter((review) => {
      if (!review || !review.text) return false;
      const key = reviewKey(review);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  // Customer reviews are added on top of the product's own reviews; they never replace them.
  function mergeReviews(live, seed) {
    const own = uniqueReviews(seed);
    const ownKeys = new Set(own.map(reviewKey));
    const customer = uniqueReviews(live).filter((review) => !ownKeys.has(reviewKey(review))).slice(0, MAX_LIVE_REVIEWS);
    return customer.concat(own);
  }

  function labelsFrom(container) {
    return {
      verified: container.dataset.i18nVerified || 'Compra verificada',
      customer: container.dataset.i18nCustomer || 'Clienta',
      daysOne: container.dataset.i18nDaysOne || 'hace 1 día',
      daysOther: container.dataset.i18nDaysOther || 'hace {{ count }} días',
      daysToday: container.dataset.i18nDaysToday || 'hoy',
    };
  }

  function paintReviews(container, reviews) {
    const list = container.querySelector('[id^="ProductCustomReviewsList-"]');
    const carousel = container.querySelector('.product-custom-reviews__carousel');
    if (!list) return;
    if (!reviews.length) {
      list.replaceChildren();
      if (carousel) carousel.hidden = true;
      return;
    }
    const labels = labelsFrom(container);
    list.replaceChildren();
    reviews.forEach((review, index) => list.appendChild(renderReview(review, labels, index, reviews.length)));
    initCarousel(container, reviews.length);
  }

  function setStatus(container, message, isError) {
    const status = container.querySelector('[data-or-review-status]');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function selectedStars(form) {
    const checked = form.querySelector('input[name="or-review-stars"]:checked');
    return checked ? Number(checked.value) : 0;
  }

  function reviewMailBody(payload) {
    return [
      'Nueva opinión publicada',
      `Producto: ${payload.productTitle}`,
      `URL: ${payload.productUrl}`,
      `Estrellas: ${payload.stars}`,
      payload.city ? `Ciudad: ${payload.city}` : '',
      `Nombre: ${payload.author}`,
      '',
      payload.text,
    ].filter(Boolean).join('\n');
  }

  function readPendingReview(handle) {
    try {
      const pending = JSON.parse(sessionStorage.getItem('or-review-pending') || 'null');
      if (!pending || pending.handle !== handle) return null;
      if (Date.now() - Number(pending.ts || 0) > 60 * 60 * 1000) {
        sessionStorage.removeItem('or-review-pending');
        return null;
      }
      return pending;
    } catch (e) {
      return null;
    }
  }

  function rememberPendingReview(review, returnUrl) {
    try {
      sessionStorage.setItem('or-review-pending', JSON.stringify(review));
      sessionStorage.setItem('or-review-return', returnUrl);
    } catch (e) {}
    try {
      document.cookie = 'or_review_return=' + encodeURIComponent(returnUrl) + ';path=/;max-age=600;SameSite=Lax';
    } catch (e) {}
  }

  function pendingToLive(pending) {
    return {
      author: pending.author,
      city: pending.city || '',
      stars: pending.stars,
      text: pending.text,
      days_ago: 0,
      verified: false,
      _ts: Math.floor(Number(pending.ts || Date.now()) / 1000),
    };
  }

  function sendReviewEmail(notifyForm) {
    if (!notifyForm) return;
    const action = String(notifyForm.action || '').replace(/#.*$/, '');
    if (!action) return;
    const params = new URLSearchParams();
    Array.from(new FormData(notifyForm).entries()).forEach(function (entry) {
      params.append(entry[0], entry[1]);
    });
    fetch(action, {
      method: 'POST',
      body: params.toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        Accept: 'text/html',
      },
      credentials: 'same-origin',
      keepalive: true,
    }).catch(function () {});
  }

  function bindForm(container, state) {
    const form = container.querySelector('.product-custom-reviews__form');
    const notifyForm = container.querySelector('.product-custom-reviews__notify');
    if (!form || form.dataset.orBound === 'true') return;
    form.dataset.orBound = 'true';
    form.removeAttribute('target');

    form.addEventListener('submit', (event) => {
      const author = ((form.querySelector('[name="comment[author]"]') || {}).value || '').trim();
      const email = ((form.querySelector('[name="comment[email]"]') || {}).value || '').trim();
      const city = ((form.querySelector('[data-or-review-city]') || {}).value || '').trim();
      const bodyField = form.querySelector('[name="comment[body]"]');
      const rawText = ((form.querySelector('[data-or-review-text]') || bodyField || {}).value || '').trim();
      const stars = selectedStars(form) || 5;
      const text = rawText.replace(/^ORREV;[^\n]+\n/, '').trim();
      const submit = form.querySelector('[type="submit"]');

      if (!author || !email || text.length < 8 || !bodyField) {
        event.preventDefault();
        setStatus(container, container.dataset.i18nError || 'No se ha podido publicar.', true);
        return;
      }

      const safeCity = city.replace(/;/g, ',');
      bodyField.value = `ORREV;${container.dataset.productHandle};${stars};${safeCity}\n${text}`;

      const returnUrl = container.dataset.productUrl || `${window.location.pathname}${window.location.search}${container.id ? '#' + container.id : ''}`;
      const returnField = form.querySelector('[name="return_to"]');
      if (returnField) returnField.value = returnUrl;

      rememberPendingReview({
        handle: container.dataset.productHandle,
        author,
        city,
        stars,
        text,
        ts: Date.now(),
      }, returnUrl);

      if (notifyForm) {
        const notifyName = notifyForm.querySelector('[data-or-notify-name]');
        const notifyEmail = notifyForm.querySelector('[data-or-notify-email]');
        const notifyBody = notifyForm.querySelector('[data-or-notify-body]');
        if (notifyName) notifyName.value = author;
        if (notifyEmail) notifyEmail.value = email;
        if (notifyBody) {
          notifyBody.value = reviewMailBody({
            author,
            city,
            stars,
            text,
            productTitle: container.dataset.productTitle || '',
            productUrl: container.dataset.productUrl || window.location.href,
          });
        }
        sendReviewEmail(notifyForm);
      }

      if (submit) submit.disabled = true;
    });
  }

  async function initContainer(container) {
    const handle = container.dataset.productHandle;
    const dataUrl = container.dataset.reviewsUrl;
    const list = container.querySelector('[id^="ProductCustomReviewsList-"]');
    const hasForm = Boolean(container.querySelector('.product-custom-reviews__form'));
    if (!handle || !list) return;

    const state = { live: parseLive(readLiveComments(container), handle), seed: [] };
    const pending = readPendingReview(handle);
    if (pending) {
      const alreadyLive = state.live.some(function (item) {
        return String(item.author || '').trim().toLowerCase() === String(pending.author || '').trim().toLowerCase()
          && String(item.text || '').trim().toLowerCase() === String(pending.text || '').trim().toLowerCase();
      });
      if (alreadyLive) {
        try { sessionStorage.removeItem('or-review-pending'); } catch (e) {}
      } else {
        state.live = uniqueReviews([pendingToLive(pending)].concat(state.live));
      }
    }

    if (dataUrl) {
      try {
        const data = await loadLocalized(dataUrl, container.dataset.locale);
        state.seed = data[handle] || [];
      } catch (e) {
        state.seed = [];
      }
    }

    const reviews = mergeReviews(state.live, state.seed);
    if (!reviews.length && !hasForm) {
      container.hidden = true;
      return;
    }

    paintReviews(container, reviews);
    if (pending) {
      setStatus(container, container.dataset.i18nSuccess || 'Tu opinión ya está publicada. Gracias.', false);
    }
    bindForm(container, state);
  }

  function boot() {
    document.querySelectorAll('.product-custom-reviews[data-product-handle]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
